// Outcast wind-down (Oct–Dec 2026).
//
// While the shutdown flag is on:
// - cancelling a subscription in Stripe marks the customer as
//   SHUTDOWN_CANCELED_STATUS instead of 'canceled', and leaves their plan
//   price, remaining credits, team seats and mail groups as they are. The app
//   treats that status as an active plan, so these customers keep using what
//   they have until it goes offline on Dec 1, 2026. Customers who cancelled
//   before the shutdown keep the plain 'canceled' status and are not affected.
// - new checkouts (subscriptions, upgrades, credit packs, seats) are refused,
//   the register page shows a "signups are closed" message, and every app page
//   shows a shutdown banner.
//
// Flags (Vercel env vars, Production):
// - OUTCAST_SHUTDOWN=true             server-side (webhooks, API routes)
// - NEXT_PUBLIC_OUTCAST_SHUTDOWN=true client-side (banner, register page,
//                                     checkout buttons). Inlined at build time,
//                                     so a redeploy is needed after changing it.
export const SHUTDOWN_CANCELED_STATUS = 'shutdown_canceled'

export const SHUTDOWN_DATE_LABEL = 'December 1, 2026'

export const SHUTDOWN_PURCHASES_DISABLED_MESSAGE = `Outcast is shutting down on ${SHUTDOWN_DATE_LABEL}, so new purchases are disabled.`

export const isShuttingDown = (): boolean =>
  process.env.OUTCAST_SHUTDOWN === 'true' ||
  process.env.NEXT_PUBLIC_OUTCAST_SHUTDOWN === 'true'
